import type { Instance } from "@wb/ui/analytics/instances";
import { identity } from "@wb/ui/analytics/posthog/identity";
import { track } from "@wb/ui/analytics/posthog/track";

export const posthog: Instance = {
  identity,
  track,
};
